// @ts-nocheck 9177b86b
import * as actionTypes from './leftTreeActionTypes';

const overrideItems = (overridden) => ({
  type: actionTypes.OVERRIDE_LEFT_TREE,
  overridden,
});

export { overrideItems };
